<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!--div class="row">
                <div class="col-xl-12 col-lg-12">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>-->
            <!-- Header container -->
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-lg-4">
                    <h3 class="my-2">User Address</h3>
                    <div class="card table-responsive">
                        <table class="table mb-0 table-borderless">
                            <tbody>
                            <tr>
                                <th>County</th>
                                <td>{{details.county}}</td>
                            </tr>
                            <tr>
                                <th>Area of residence</th>
                                <td>{{details.location_name}}</td>
                            </tr>
                            <tr>
                                <th>Address</th>
                                <td>{{details.address}}</td>
                            </tr>
                            <div class="form-group p-3">
                                <label>Change status</label>
                                <select v-model="details.status" @change="changeStatus($event)"
                                        class="form-control form-control-sm">
                                    <option value="0">Active</option>
                                    <option value="1">Suspend</option>
                                </select>
                            </div>
                            </tbody>
                        </table>
                        <div class="form-group p-3"
                             v-if="details.role == 'wholesaler' || details.role == 'retailer' || details.role == 'rider'">
                            <label>Change verification status</label>
                            <select v-model="form.verification" @change="changeVerification($event)"
                                    class="form-control form-control-sm">
                                <option value="verified">Verified</option>
                                <option value="unverified">Unverified</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <h3 class="my-2">User Details</h3>
                    <div class="card">
                        <table class="table mb-0 table-borderless">
                            <tbody>
                            <tr>
                                <th>Name</th>
                                <td>{{details.name}}</td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>{{details.email}}</td>
                            </tr>
                            <tr>
                                <th>Phone Number</th>
                                <td>{{details.phone}}</td>
                            </tr>
                            <tr>
                                <th>Role</th>
                                <td>{{details.role}}</td>
                            </tr>
                            <th>Status</th>
                            <td>
                                <span v-if="details.status == 0" class="badge badge-success">Active</span>
                                <span v-if="details.status == 1" class="badge badge-warning">Suspended</span>
                            </td>
                            <tr v-if="details.role == 'wholesaler' || details.role == 'retailer'">
                                <th>Verification</th>
                                <td>
                                    <span v-if="details.shop.verification == 'verified'" class="badge badge-success">Verified</span>
                                    <span v-if="details.shop.verification == 'unverified'" class="badge badge-warning">Not Verified</span>
                                </td>
                            </tr>
                            <tr v-if="details.role == 'rider'">
                                <th>Verification</th>
                                <td>
                                    <span v-if="details.ride.verification == 'verified'" class="badge badge-success">Verified</span>
                                    <span v-if="details.ride.verification == 'unverified'" class="badge badge-warning">Not Verified</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Registration Date</th>
                                <td>{{moment(details.created_at).format('MMMM Do YYYY, h:mm:ss a')}}</td>
                            </tr>
                            <tr  v-if="details.role == 'rider'">
                                <th>Upload Documents</th>
                                <td><button class="btn btn-success btn-sm "  data-toggle="modal" data-target="#uploadDocuments" @click="uploadModal(details)">Upload</button></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card card-outline-secondary my-4"  v-if="details.role == 'rider'">
                        <div class="card-header">
                            <i class="fas fa-id-card"></i> Riders Documents
                        </div>
                        <div>
                            <div class="card-body table-responsive">
                            <table class="table table-hover shopping-cart-wrap">
                                <thead class="text-muted">
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col" >file</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr  v-for="file in files" :key="file.id" >
                                    <td>
                                        {{file.name}}
                                    </td>
                                    <td>
                                         <div v-if="file.type ==='image'">
                                           <figure class="media">
                                            <div class="img-wrap"><img :src="file.filePath"
                                                                       class="img-thumbnail img-sm"
                                                                       style="width: 90px;">
                                            </div>
                                        </figure>
                                        </div>
                      
                                        <div v-if="file.type !=='image'">
                                            <button type="button" class="btn btn-success btn-sm fas fa-cloud-download-alt"  @click.prevent="download(file.id, file.filename)"></button>
                                        </div>
                                      
                                    </td>
                                    <td>
                                          <button type="button" class="btn btn-danger btn-sm fa fa-trash-alt"  @click="deleteDoc(file.id)"></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        </div>
                    </div>
                </div>
                
                
                    <!-- Rider Documents Modal-->
                    <div class="modal fade uploadDocuments-modal-lg" tabindex="-1"   id="uploadDocuments" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4>Upload Rider's Documents</h4>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form method="post" @submit.prevent="uploadDocs">
                                        <div class="form-group">
                                            <label>Upload Rider's Documents<span class="required">*</span></label>
                                                <VueFileAgent
                                                        :accept="'image/*,.pdf,.doc,.docx,.ods'"
                                                        :multiple="true"
                                                        :deletable="true"
                                                        :maxSize="'10MB'"
                                                        :maxFiles="14"
                                                        v-model="attachments"
                                                        @select="filesSelected($event)"
                                                        @delete="fileDeleted($event)">
                                                </VueFileAgent>
                                                <small style="color: red" v-if="error && errors.files">{{ errors.files[0] }}</small>
                                                <small style="color: red" v-if="errn && errnv.files">{{ errnv.files}}</small>
                                        </div>
                                        <hr>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Close</button>
                                            <button type="submit" class="btn btn-success btn-sm">Upload Rider Documents</button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>
<script>
// Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    let moment = require('moment');
    export default {
        name: 'userDetails',
        components: {
            Loading
        },
        data() {
            return {
                moment,
                id: this.$route.params.id,
                details: [],
                filesDataForUpload: [],
                attachments: [],
                errors: {},
                error: false,
                errn: false,
                errnv: {},
                isLoading: false,
                fullPage: true,
                files:{},
                form: {
                    status: '',
                    verification: ''
                },
                 formD: {
                    rider_id:'',
                }
            }
        },
        methods: {
            changeVerification(event) {
                this.form.status = event.target.value;
                this.$swal.fire({
                    title: "Are you sure!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.patch("/admin/changeVerificationStatus/" + this.id, this.form).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Updated successfully',
                                'success'
                            )
                            this.getDetails();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            download(id, filename) {
                this.axios.get("/admin/download/" + id, {responseType: 'blob'})
                    .then((response) => {
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', filename.substring(8));
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    });
            },
           
            deleteDoc($id){
                    this.$swal.fire({
                    title: "Are you sure!",
                    text: "This document will be deleted permanetly!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Delete Doc!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.get("/admin/deleteDocs/" + $id).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Doc deleted successfully',
                                'success'
                            )
                            this.getFiles();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            changeStatus(event) {
                this.form.status = event.target.value;
                this.$swal.fire({
                    title: "Are you sure!",
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, update status!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.patch("/admin/changeStatus/" + this.id, this.form).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Status updated successfully',
                                'success'
                            )
                            this.getDetails();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
             fileDeleted: function (fileData) {
                var i = this.filesDataForUpload.indexOf(fileData);
                if (i !== -1) {
                    this.filesDataForUpload.splice(i, 1);
                } else {
                    this.deleteUploadedFile(fileData);
                }
            },
            filesSelected: function (filesDataNewlySelected) {
                var validFilesData = filesDataNewlySelected.filter((fileData) => !fileData.error);
                this.filesDataForUpload = this.filesDataForUpload.concat(validFilesData);
            },
            uploadDocs(){
                    if (!this.filesDataForUpload.length) {
                        this.errn = true;
                        this.errnv.files = 'This field is required!';
                        return false;
                    }
                    this.errn = false;
                    this.errnv.files = '';
                     this.isLoading = true;
                let fd = new FormData();
                for (let i = 0; i < this.filesDataForUpload.length; i++) {
                    fd.append('files[]', this.filesDataForUpload[i].file);
                }
                      fd.append('id', this.formD.rider_id);

                 const config = {headers: {'Content-Type': 'multipart/form-data'}};
                 this.axios.post('/admin/riderDocuments', fd, config).then(() => {
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success!!',
                        text: 'Documents Uploaded Successfully',
                    });
                    this.filesDataForUpload = [];
                    this.attachments = [];
                   
                })
                    .catch(error => {
                        this.isLoading = false;
                        this.error = true;
                        this.errors = error.response.data.errors;
                    });
            },
            getFiles(){
                this.axios.get('admin/riderDocs/' + this.id).then(({data})=>([this.files = data]));
            },
            getDetails() {
                this.axios.get('/admin/userDetails/' + this.id).then((data) => {
                    this.details = data.data
                    if (data.data.role == 'wholesaler' || data.data.role == 'retailer') {
                        this.form.verification = data.data.shop.verification
                    }

                    if (data.data.role == 'rider') {
                        this.form.verification = data.data.ride.verification
                    }
                });
            },
            uploadModal(details){
            this.formD.rider_id = details.id;
            },
            close() {
                ('#uploadDocuments').modal('hide');
            },
        },
        created() {
            this.getDetails();
            this.getFiles();
        },

    }
</script>
<style></style>
